import React, { useEffect, useContext, useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AppContext, DispatchContext } from "../AppContext";
import Service from "../services/service";
import * as actions from "../actions/actions";
import { showCaptcha, config, resolveNotificationMessage } from '../helpers/constants';
import { Box, Paper, Typography, Button } from "@material-ui/core";
import FullScreenPage from "./FullScreenPage";
import LicenseQuotePanel from './LicenseQuotePanel';
import DividerLabel from "./DividerLabel";
import { ReactComponent as CheckedIcon } from '../assets/icons/checked.svg';
import LoadingScreen from "./LoadingScreen";


const useStyles = makeStyles((theme) => ({
  paper: {
    width: 850,
    minHeight: 500,
    position: "relative",
    boxShadow: "0px 0px 5px 5px rgba(0, 0, 0, 0.25)",
    "&:hover": {
      boxShadow: "0px 0px 7px 7px rgba(0, 0, 0, 0.4)",
      transition: "box-shadow 0.3s ease-in-out",
    }
  }
}));

export default function Quote(props) {
  const dispatch = useContext(DispatchContext);
  const state = useContext(AppContext);
  const s = state.strings;
  const classes = useStyles();
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!state.user.loggedIn) {
      showCaptcha();
    }
  }, []);

  const onSendQuoteButtonClicked = (e) => {
    setLoading(true);
    e.preventDefault();
    if (state.user.loggedIn) {
      sendQuoteMail();
    } else {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(config.captchaKey, { action: 'sendQuoteMail' }).then(function (token) {
          Service.verifyReCaptcha(token).then((verifyRes) => {
            if (verifyRes.success) {
              sendQuoteMail();
            } else {
              setLoading(false);
              dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(verifyRes.errors[0], s.notificationMessage) }));
            }
          });
        });
      });
    }
  }

  const sendQuoteMail = () => {
    Service.sendQuoteMail(state.checkout.education).then(res => {
      setLoading(false);
      if (res.success) {
        setSent(true);
        dispatch(actions.openToast({ type: "success", message: resolveNotificationMessage(res.message, s.notificationMessage) }));
      } else {
        dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage) }));
      }
    });
  }

  const onCancelButtonClicked = () => {
    // real redirect to get rid of Captcha script
    window.location.href = config.backendUrl + s.links.home;
  }

  if (sent) {
    return (
      <FullScreenPage>
        <Paper elevation={5} className={classes.paper}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", padding: 60 }}>
            <Box mt={2} />
            <CheckedIcon style={{ fill: '#009900' }} height={100} width={100} />
            <Box mt={4} />
            <Typography paragraph variant="h6">{s.paymentDialog.thanksForQuoteRequest}</Typography>
            <Typography align="center" color="secondary">{s.paymentDialog.thanksForQuoteRequestText}</Typography>
            <Box mt={4} />
            <Button onClick={onCancelButtonClicked} variant="outlined" style={{ marginLeft: 8 }}>{s.common.close}</Button>
          </div>
        </Paper>
      </FullScreenPage>
    )
  }

  return (
    <FullScreenPage>
      <Paper elevation={5} className={classes.paper}>
        <LoadingScreen status={loading} opacity={0.75} text={s.quotePanel.sendingMessage} />
        <div style={{ padding: 32 }}>
          <Typography paragrpah variant="h6">{s.paymentDialog.requestEduQuoteTitle}</Typography>
          <DividerLabel />
          <LicenseQuotePanel />
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 24 }}>
            <Button onClick={(e) => onSendQuoteButtonClicked(e)} disabled={!state.checkout.education.complete} variant="contained" color="primary">{s.paymentDialog.sendQuote}</Button>
            <Button onClick={onCancelButtonClicked} variant="outlined" style={{ marginLeft: 8 }}>{s.common.cancel}</Button>
          </div>
        </div>
      </Paper>
    </FullScreenPage>
  );
}
